<template>
  <div class="auth-page-wrapper">
    <AuthCard class="auth-page">
      <template #header>
        <div class="auth-page__logo">
          <img :src="logo" alt="logo" />
          <img :src="assistant" alt="assistant" />
        </div>
      </template>
      <a-space class="auth-page__progress">
        <a-spin size="large" />
      </a-space>
    </AuthCard>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { AuthCard } from '@/ui/common/auth'
import { useAuthStore } from '@/store/auth-store'
import logo from '@/assets/icons/menu/logo.svg'
import assistant from '@/assets/icons/menu/assistant.svg'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const { locale } = useI18n()
const localeStorge = useStorage('locale', import.meta.env.VITE_APP_LANG)

const router = useRoute()

const { exchangeToken, setAuthData } = useAuthStore()

onMounted(async () => {
  if (router.query.l && (router.query.l === 'ru-RU' || router.query.l === 'en-US')) {
    locale.value = router.query.l
    localeStorge.value = router.query.l
  }

  if (router.query.t) {
    await exchangeToken(router.query.t.toString())
  }

  if (router.query.at) {
    await setAuthData(router.query.at.toString())
  }
})
</script>

<style lang="scss" scoped>
.auth-page-wrapper {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  .auth-page {
    &__logo {
      display: flex;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px 24px;
      gap: 8px;
    }
    &__progress {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px 24px;
    }
  }
}
</style>
